<template>
  <v-alert
      dense
      outlined
      type="error"
      v-if="displayedMessages.length > 0"
  >
    <span
        v-for="(message,i) in displayedMessages"
        :key="i"
    >
      {{ message }}<br>
    </span>
  </v-alert>
</template>

<script>
export default {
  name: 'GlobalValidationErrors',
  props: ['value'],
  computed: {
    displayedMessages() {
      if(this.value == null) {
        return [];
      }
      if(Array.isArray(this.value)) {
        return this.value;
      }
      if(typeof this.value === 'object') {
        return this.value[''] || [];
      }
      return [this.value];
    }
  }
}
</script>

<style scoped>
.v-alert::v-deep .v-alert__icon {
  align-self: center;
}
</style>